import type { IconData } from '@stacksjs/iconify-core'

export const smallArrowRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M23 44q10 0 16 6l163 162q7 8 7 17t-7 16L39 407q-7 7-16 7t-16-7t-7-16t7-16l146-146L7 83q-7-7-7-17t6.5-16T23 44\"/>",
  "width": 210,
  "height": 700,
  "viewBox": "0 0 210 700"
}

export default smallArrowRight
